<nz-spin [nzSpinning]="loading" nzSize="large">
  <nz-page-header nzBackIcon [nzGhost]="false" (nzBack)="goHome()">
    <nz-page-header-title>{{ this.translate.currentLang === 'ru' ? article?.title.ru : article?.title.en }}</nz-page-header-title>
    <nz-page-header-subtitle>{{ article?.publishedAt | date: 'short' }}</nz-page-header-subtitle>
    <nz-page-header-content>
      <div class="content skiptranslate" [innerHTML]="this.translate.currentLang === 'ru' ? article?.content.ru : article?.content.en"></div>
    </nz-page-header-content>
  </nz-page-header>
</nz-spin>
